module.exports = __webpack_public_path__ + "img/511.61b79780.png";